import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  selectTrainingType,
  TrainingType,
} from "../../app/slices/TrainingSlice";
import { useCloseQuizFeedback } from "./QuizFeedbackColumn.hook";

// slim rail shown in place of the takes column while quiz feedback is open;
// only the header chevron is interactable and restores the normal view
export default function QuizFeedbackCollapsedRail() {
  const { t } = useTranslation();
  const close = useCloseQuizFeedback();
  const trainingType = useSelector(selectTrainingType);
  const unitLabel = t(
    trainingType === TrainingType.Training360 ? "bubbles" : "takes"
  ) as string;

  return (
    <div
      className="w-full h-full flex flex-col bg-creator-surface border-r border-creator-border"
      data-testid="quiz-feedback-collapsed-rail"
    >
      <div className="h-[42px] min-h-[42px] flex items-center justify-center bg-creator-primary-background border-b border-creator-border">
        <button
          type="button"
          className="inline-flex items-center justify-center w-[24px] h-[24px] rounded-5 border-0 bg-transparent text-creator-text-sub hover:bg-creator-childHover cursor-pointer"
          onClick={close}
          title={unitLabel}
          aria-label={unitLabel}
          data-testid="quiz-feedback-collapsed-rail-button"
        >
          <ChevronLeftOutlinedIcon fontSize="small" />
        </button>
      </div>
    </div>
  );
}
